import { store } from '../../store/store';
import { actions, behaviorState, handleStateChange, events, updateTranslations, } from './sdk';
import { BehaviorSubject } from 'rxjs';
import { messageHandler } from './message-handler';
import ImportExtensionTranslations from './helpers/importExtensionTranslations';
const extensionsModules = new Map();
export const interpreterUids = [];
export const extensionsSubject = new BehaviorSubject([]);
export const extensionCallMenuItemsSubject = new BehaviorSubject([]);
export const extensionMainMenuItemsSubject = new BehaviorSubject([]);
export const modalSubject = new BehaviorSubject(null);
export const callFrameSubject = new BehaviorSubject(null);
extensionsSubject.subscribe((extensions) => {
    const callMenu = [];
    const mainMenu = [];
    for (const ext of extensions) {
        if (Boolean(ext.extensionCallMenuItems)) {
            callMenu.push(...ext.extensionCallMenuItems.map((item) => ({
                props: item,
                extensionName: ext.name,
            })));
        }
        if (Boolean(ext.extensionMainMenuItems)) {
            mainMenu.push(...ext.extensionMainMenuItems.map((item) => ({
                props: item,
                extensionName: ext.name,
            })));
        }
    }
    extensionCallMenuItemsSubject.next(callMenu);
    extensionMainMenuItemsSubject.next(mainMenu);
});
export const installExtension = async (extensionName, extensionCode) => {
    // todo: will be changed after implementation CS-2832 and CS-2834 user stories
    let extension = null;
    if (extensionCode.startsWith('http')) {
        extension = window[extensionName];
    }
    else if (extensionCode) {
        const extensionModule = await import(`./extensions/${extensionCode}`);
        extension = extensionModule.default;
    }
    if (!extension) {
        return;
    }
    extensionsModules.set(extensionName, extension);
    if ((Boolean(extension.translations))) {
        updateTranslations(ImportExtensionTranslations(extension.name, extension.translations));
    }
    if (Boolean(extension.install)) {
        extension.install({
            state: behaviorState,
            actions: actions,
            events: events,
        });
    }
    extensionsSubject.next([...extensionsModules.values()]);
};
const loadExtensionModule = (extensionName, extensionCode) => {
    const script = document.createElement('script');
    script.setAttribute('id', `ext-module-${extensionName}`);
    script.type = 'text/javascript';
    script.src = extensionCode;
    document.querySelector('head').append(script);
    script.addEventListener('load', () => {
        void installExtension(extensionName, extensionCode);
    });
};
const loadExtensionStyles = (extensionName, extensionStyle) => {
    const link = document.createElement('link');
    link.setAttribute('id', `ext-style-${extensionName}`);
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = extensionStyle;
    document.querySelector('head').append(link);
};
export const loadAndInstallExtension = async (extensionName, extensionCode) => {
    if (extensionsModules.get(extensionName) ||
        !extensionName ||
        !extensionCode) {
        return;
    }
    extensionsModules[extensionName] = null;
    // todo: will be changed after implementation CS-2832 and CS-2834 user stories
    if (extensionCode.startsWith('http')) {
        loadExtensionModule(extensionName, extensionCode);
        // todo: will be changed after approved approach how we import extensions
        loadExtensionStyles(extensionName, extensionCode.replace('.js', '.css'));
    }
    else {
        await installExtension(extensionName, extensionCode);
    }
};
const uninstallExtensionModule = (extensionName) => {
    const script = document.querySelector(`#ext-module-${extensionName}`);
    if (script) {
        script.remove();
    }
};
const uninstallExtensionStyles = (extensionName) => {
    const link = document.querySelector(`#ext-style-${extensionName}`);
    if (link) {
        link.remove();
    }
};
export const uninstallExtension = (extensionName) => {
    const extension = extensionsModules.get(extensionName);
    if (extension?.uninstall) {
        extension.uninstall();
    }
    uninstallExtensionModule(extensionName);
    uninstallExtensionStyles(extensionName);
    extensionsModules.delete(extensionName);
    extensionsSubject.next([...extensionsModules.values()]);
};
export const resetState = () => {
    extensionsModules.clear();
    extensionsSubject.next([]);
};
export const extensionsStoreWatch = () => {
    // Supplies extensions with updated state
    store.subscribe(handleStateChange);
};
export const messagesStoreWatch = () => {
    store.subscribe(() => {
        void messageHandler();
    });
};
